var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.hillsBatches),function(batches){return _c('li',{key:batches.id},[_c('ul',{staticStyle:{"display":"inline"}},[_vm._v("\n          "+_vm._s(batches.Id)+" "+_vm._s(batches.Name)+" "+_vm._s(batches.FormSize)+" \n\t\t\t\t")])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb478c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/TestingPages/Test.vue
// module id = null
// module chunks = 